/*
 * Shapes an /api/search response before any surface renders it.
 * 1. Cross-store product links are resolved against their store's URL
 *    ("/products/x" -> "https://neuroganhealth.com/products/x"), so the
 *    renderers' host check accepts them instead of rendering "#".
 * 2. Pins (theme setting ai_search_pins, one rule per line:
 *    "search phrase | handle, handle"): for that exact phrase, show only
 *    those products, in that order, from whichever store has them. A rule
 *    whose handles match nothing leaves the results untouched.
 * 3. Products the index marks unavailable (available === false) are dropped
 *    from every list, so no surface ever offers something shoppers can't buy.
 * Pure + fail-soft: any error returns the input unchanged.
 */
(function () {
  function normalize(s) {
    return String(s == null ? '' : s).toLowerCase().normalize('NFD')
      .replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function parsePins(text) {
    var pins = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf('|');
      if (i === -1) return;
      var q = normalize(line.slice(0, i));
      var handles = line.slice(i + 1).split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      if (q && handles.length) pins[q] = handles;
    });
    return pins;
  }

  function absolute(url, base) {
    if (!url) return url;
    try { return new URL(url, base).href; } catch (e) { return url; }
  }

  function buyable(list) {
    return (list || []).filter(function (p) { return p && p.available !== false; });
  }

  function shapeResult(data, pinsText) {
    try {
      if (!data) return data;
      var blocks = (data.crossStore || []).map(function (b) {
        return Object.assign({}, b, {
          products: buyable(b.products).map(function (p) { return Object.assign({}, p, { url: absolute(p.url, b.url) }); }),
        });
      }).filter(function (b) { return b.products.length; });
      var out = Object.assign({}, data);
      if (data.crossStore) out.crossStore = blocks;
      if (data.products) out.products = buyable(data.products);
      if (data.suggestions) out.suggestions = buyable(data.suggestions);
      if (out.bestMatch && !(out.products || []).some(function (p) { return p.slug === out.bestMatch; })) out.bestMatch = null;
      data = out;

      var handles = parsePins(pinsText)[normalize(data.query)];
      if (!handles) return out;
      var pick = function (list) {
        return handles.map(function (h) {
          for (var i = 0; i < list.length; i++) if (list[i].slug === h) return list[i];
          return null;
        }).filter(Boolean);
      };
      var own = pick(out.products || []);
      var pinnedBlocks = blocks.map(function (b) {
        return Object.assign({}, b, { confidence: 'high', products: pick(b.products) });
      }).filter(function (b) { return b.products.length; });
      if (!own.length && !pinnedBlocks.length) return out;

      out.products = own;
      out.articles = [];
      out.bestMatch = own.length ? own[0].slug : null;
      if (data.crossStore) out.crossStore = pinnedBlocks;
      return out;
    } catch (e) {
      return data;
    }
  }

  var api = { shapeResult: shapeResult, parsePins: parsePins, normalize: normalize };
  if (typeof window !== 'undefined') window.AISearchShape = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})();
